@for (menu of parentMenu; track menu) {
  <div class="menu-item">
    <ul class="menu-ul">
      <li [routerLinkActive]="['active-parent-menu-admin']" [routerLinkActiveOptions]="{ exact: true }">
        @if (menu.routerLink && !menu.hasSubMenu) {
          <a
            mat-button fxLayout="row" fxLayoutAlign="start center" [routerLink]="[menu.routerLink]"
            routerLinkActive="active-link"
            [routerLinkActiveOptions]="(menu.parentId != 0) ? { exact:false } : {exact:true}"
            (click)="onClick(menu.id)" [id]="'menu-item-'+menu.id">
            @if (menu.icon) {
              <mat-icon class="menu-icon">{{menu.icon}}</mat-icon>
            }
            @if (!menu.icon) {
              <mat-icon [svgIcon]="menu.svgIcon" class="menu-icon"></mat-icon>
            }
            <span class="menu-title">{{ menu.title | translate }}</span>
          </a>
        }
      </li>
      <li [routerLinkActive]="['active-parent-menu-admin']" [routerLinkActiveOptions]="{ exact: true }">
        @if (menu.href && !menu.subMenu) {
          <a mat-button fxLayout="row" fxLayoutAlign="start center"
            [attr.href]="menu.href || ''" [attr.target]="menu.target || ''" (click)="onClick(menu.id)"
            [id]="'menu-item-'+menu.id">
            @if (menu.icon) {
              <mat-icon class="menu-icon">{{menu.icon}}</mat-icon>
            }
            @if (!menu.icon) {
              <mat-icon [svgIcon]="menu.svgIcon" class="menu-icon"></mat-icon>
            }
            <span class="menu-title">{{ menu.title | translate }}</span>
          </a>
        }
      </li>
      <li [routerLinkActive]="['active-parent-menu-admin']" [routerLinkActiveOptions]="{ exact: true }">
        @if (menu.hasSubMenu) {
          <a mat-button fxLayout="row" fxLayoutAlign="start center" (click)="onClick(menu.id)"
            [id]="'menu-item-'+menu.id">
            @if (menu.icon) {
              <mat-icon class="menu-icon">{{menu.icon}}</mat-icon>
            }
            @if (!menu.icon) {
              <mat-icon [svgIcon]="menu.svgIcon" class="menu-icon"></mat-icon>
            }
            <span class="menu-title">{{ menu.title | translate }}</span>
            <mat-icon class="menu-expand-icon transition-2">arrow_drop_down</mat-icon>
          </a>
        }
      </li>
    </ul>
    @if (menu.hasSubMenu) {
      <div class="sub-menu" [id]="'sub-menu-'+menu.id">
        <app-menu [menuItems]="menuItems" [menuParentId]="menu.id"></app-menu>
      </div>
    }
  </div>
}
<mat-divider></mat-divider>
<div fxLayout="row" fxLayoutAlign="center" fxLayoutGap="5px" class="mt-1 user-info">
  <mat-icon>perm_identity</mat-icon>
  <span class="menu-title">{{userId}}</span>
</div>
